/**
 * @generated SignedSource<<3bb1923a7c1618931b1eeb64a0a5007a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type AuthContextMeQuery$variables = Record<PropertyKey, never>;
export type AuthContextMeQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AuthContext_user">;
};
export type AuthContextMeQuery = {
  response: AuthContextMeQuery$data;
  variables: AuthContextMeQuery$variables;
};

const node: ConcreteRequest = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "AuthContextMeQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "AuthContext_user"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "AuthContextMeQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "107e6ce7f8fbd35a46c8e57c1a212bec",
    "id": null,
    "metadata": {},
    "name": "AuthContextMeQuery",
    "operationKind": "query",
    "text": "query AuthContextMeQuery {\n  ...AuthContext_user\n}\n\nfragment AuthContext_user on Query {\n  me {\n    id\n    firstName\n    lastName\n    email\n  }\n}\n"
  }
};

(node as any).hash = "47199fe2ebfd32f4e00b8a1bacc14c0e";

export default node;
